<template>
    <div class="input-group" :style="fieldStyles()">
      <field-icon :fieldData="fieldData"></field-icon>

      <input
        :disabled="(!!showDisabled())"
        :type="'text'"
        :ref="fieldData.field_name"
        :id="fieldData.field_name"
        :name="fieldData.field_name"
        v-model="vanityData"
        v-validate="field_rules"
        @focus="$event.target.select()"
        @blur="apiRule.present && apiRule.type == 'onblur' ? postRule($event.target.value, fieldData) :  ''"
        :placeholder="fieldData.placeholder"
        :maxlength="fieldData.max_length"
        autocomplete="off"
        v-bind:class="{'form-control': true,
          'error': errors.has(fieldData.field_name) || fieldData.has_error}">
        <span v-bind:class="{'warning fas fa-exclamation-triangle': errors.has(fieldData.field_name)  || fieldData.has_error }"></span>
    </div>
</template>

<script>
import FieldIcon from '../presentational/FieldIcon';
import { inputFieldMixin } from '../../mixins/inputFieldMixin';

export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'sendPostRule'],
  components: { FieldIcon },
  mixins: [inputFieldMixin],
  data() {
    return {
      starValue: '********', // TODO: Use config value
      realValue: '',
      lastFour: '',
      touched: false,
    };
  },
  computed: {
    vanityData: {
      get() {
        if (!this.touched) {
          return this.starValue; // The value appears as asterisks '********' until it has been edited aka touched
        }

        return this.realValue; // If it has been edited, then display the text that has been entered
      },
      set(newValue) {
        if (!this.touched) {
          this.touched = true; // The field has been edited
          this.realValue = newValue.replace(/\*/g, ''); // Remove the asterisks from the value (i.e. '*****z***' will now be 'z')
          this.realValue = this.realValue.replace(this.lastFour, ''); // TODO: Don't allow lastFour to ever remain. This hack won't work if value added to middle of lastFour.
        } else {
          this.realValue = newValue; // Otherwise, continue to edit as usual
        }

        this.fieldData.field_value = this.realValue; // Store the new value in its property so it will be sent on the next request
      },
    },
  },
  created() {
    if (!this.fieldData.field_value) {
      this.starValue = ''; // Don't show asterisks if there is no value
    } else {
      const fieldValue = this.fieldData.field_value;
      const fieldValueLength = (fieldValue.length > 4 ? fieldValue.length : 4);
      this.lastFour = fieldValue.slice(fieldValueLength - 4, fieldValueLength);
      this.starValue = Array(fieldValueLength - 3).join('*') + this.lastFour;
    }
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputTextpii.vue?9cb401c6